/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import { useEffect,useCallback,useContext ,useState} from "react"
import { useDispatch,useSelector } from 'react-redux'
import { Link, useLocation,useSearchParams} from 'react-router-dom'
import TopHeader from '../../../components/TopHeader'
import TopBar from '../../../components/TopBar'
import Table from './Component/Table'
import GlobalContext from '../../../components/Context/GloablContext'
import Emptyscreen from '../../../components/EmptyScreen'
import Pagination from '../../../components/Pagination'
import Debounce from '../../../CommonMethods/Debounce'
import Limit from '../../../components/Limit'
import CustomOverLay from '../../../components/CustomOverLay'
import { handleAddFilterValues, handleIsViewScreen, resetFilterState } from '../../../redux/systemConfigSlice'
import moment from 'moment'
import { useExportActivityHistoryMutation } from '../../../features/apiSlice'
import { useGetActivityHistoryQuery } from '../../../features/apiSlice'
import SearchEmptyScreen from '../../../components/SearchEmptyScreen'
import HelpGuideModal from '../../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../../features/patientSlice'

export default function ManageAdminActivityHistory() {

    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar} = useContext(GlobalContext);
    const [limit,setLimit]=useState("15")
    const [exportActivityHistory]=useExportActivityHistoryMutation()
    const dispatch=useDispatch()
    const [suggestions,setSuggestions]=useState("")
    const [skip,setSkip]=useState(true)
    const location=useLocation()
    const [listingState] = useState(() => Array.isArray(location.state) ? (location.state[3] ?? '') : '')
    const [searchParams, setSearchParams] = useSearchParams({'filter':'true'});
    const viewId=useSelector((state)=>state?.systemConfigData?.viewToHistory)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const {data,isFetching,isLoading,isError,status,isSuccess}=useGetActivityHistoryQuery(searchParams?.toString(),{skip:skip,refetchOnMountOrArgChange: true})
    const initialState={
        "filter_start_date":'',
        "filter_end_date":'',
        'column_field':'',
        'action_performed':''
    }
    const [filterValues,setFilterValues]=useState(initialState)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=admin-observer-view-activity-logs');
        } else {
            setQueryParamsadmin('type=admin-view-admin-activity-logs');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
        

    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    useEffect(() => {
        if(Array.isArray(location.state)&&location.state[1]===true){
            dispatch(handleIsViewScreen([location?.state?.[2]]))
        }

        const params = Object.fromEntries(searchParams)
        let changed = false
        if(!params.limit){ params.limit = '15'; changed = true }
        if(params.filter===undefined){ params.filter = 'true'; changed = true }
        if(!params.page_number){ params.page_number = '1'; changed = true }
        if(!params.target_user_name && location.state !== null){ params.target_user_name = location?.state?.[0]; changed = true }
        if(changed) setSearchParams(params, { replace: true })

        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')

    }, [location]);
    useEffect(()=>{
        
        if(searchParams.size>=4 ){
            setSkip(false)
        }
       
        else{
            setSkip(true)
        }
        if(searchParams.get("field")===null&&searchParams.get("action")===null&&searchParams.get("start_date")===null&&searchParams.get("end_date")===null){
            dispatch(resetFilterState())
        }
    },[searchParams])


    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }
    const handleChange = (val) => {
        handleSearchParams('search', val)
        
    };
    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );
    const handleApplyFilter=(type)=>{
        const fieldsToMatch={
            "Email Address": "email_address",
            "Mobile Number":"mobile_number",
            "Main Number": "main_number",
            "County Code": "country_code",
            'User Type':'user_type',
            'User ID':'user_id',
            'Status':'Status',
            'Profile Page':'Profile Page'
        }[filterValues.column_field]

        const actionsToMatch={
            'Created':'Created',
            'Deleted':'Deleted',
            'Updated':'Updated',
            'Activated':'Activated',
            'Deactivated':'Deactivated',
            'View':'View'

        }[filterValues.action_performed]
        let params = Object.fromEntries(searchParams);
        const start_date=moment(filterValues.filter_start_date).format('YYYY-MM-DD')
        const end_date=moment(filterValues.filter_end_date).format('YYYY-MM-DD')
        dispatch(handleAddFilterValues({
            "filter_start_date":filterValues.filter_start_date,
            "filter_end_date":filterValues.filter_end_date,
            'column_field':filterValues.column_field,
            'action_performed':filterValues.action_performed

        }))
        if(type){
            params.page_number=1
            filterValues.column_field!==""?params["field"]=fieldsToMatch:''
            filterValues.action_performed!==""?params["action"]=actionsToMatch:''
            filterValues.filter_start_date!==""?params["start_date"]=start_date:''
            filterValues.filter_end_date!==""?params["end_date"]=end_date:''
            setSearchParams({...params})
        }
        else{
            params["field"]&& delete params["field"]
            params["action"]&&delete params["action"]
            params.start_date&&delete params.start_date
            params.end_date&&delete params.end_date
            setSearchParams({ ...params})
        }
        

        
    }
    return (
        <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
            <TopHeader title={"Activity Log"}/>
            <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                <div className='px-6'>
                    <div className='flex items-center mb-3.5'>
                        <Link to="/manage-admin-corporate" state={listingState}>
                            <h1 className="text-sm font-normal text-[#52555D]">List of Admin/Corporate Users</h1>
                        </Link>
                        <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        {viewId!==""&&<>
                            <Link to={`/manage-admin-corporate/${viewId}`} state={listingState}>
                                <h1 className="text-sm font-normal text-[#52555D]">View Admin/Corporate Users</h1>
                            </Link>
                            <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        </>}
                        <h1 className="text-sm font-normal text-[#008586]">Activity Log</h1>
                        {
                            userType !=='super-admin' &&
                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span> 
                        }
                    </div>
                    <TopBar 
                        path={(data?.data?.length===0 ||data===undefined) ? "" : viewId!==""&&suggestions.trim()===''?`/manage-admin-corporate/${viewId}`:suggestions.trim()===''?'/manage-admin-corporate/':'/manage-admin-corporate/activity_history'}
                        pathPlaceholder={((data?.data?.length===0 ||data===undefined)&&(searchParams.get('search')!==null||(searchParams.get("field")!==null||searchParams.get("action")!==null||searchParams.get("start_date")!==null||searchParams.get("end_date")!==null))) ? 'Go back to Activity Log' : viewId!==""?'Go back to View Admin/Corporate Users':'Go back to List of Admin/Corporate Users'}
                        // AddButton={(data?.data?.length===0) ? false : true}
                        SearchInput={false}
                        AdminCorporateSearch={true}
                        // buttonName={"Add User"}
                        // menuBar={(data!==undefined&&selectedRows?.length>0) ? true : false}
                        ApplyFilter={(searchParams.get("field")===null&&searchParams.get("action")===null&&searchParams.get("start_date")===null&&searchParams.get("end_date")===null&&(data?.data?.length===0 || data===undefined)) ? false : true}
                        suggestions={suggestions}
                        setSuggestions={setSuggestions}
                        handleApplyFilter={handleApplyFilter}
                        optimizedFn={optimizedFn}
                        data={data}
                        exportCols={['Username','Timestamp','Action Performed','Field','Old Value','New Value','Comments']}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        initialState={initialState}
                        username={searchParams.get("target_user_name")}
                        exportUsers={exportActivityHistory}
                        isIdexport={true}
                        adminOrCorporateExport={true}
                        pathState={listingState}
                    />
                </div>
                {((isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Activity Logs..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay1':'overlay-list1'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>  
                    <div className="px-6"> 
                        <Table
                            pageNumber={Number(searchParams.get('page_number')) || 1}
                            List={data}
                            handleSearchParams={handleSearchParams}
                        />
                    </div>
                    {data?.total_count>=15&&<div className="w-[100%] px-2.5 pt-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-lg">
                        <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                        <div className="flex items-center">
                            <Limit
                                limit={limit}
                                setLimit={setLimit}
                                handleNoOfRowsClick={handleNoOfRowsClick}IsColumnSelect
                                isColumnSelect={isColumnSelect}
                            />
                        
                            <Pagination
                                TotalCount={parseInt(data?.total_count)}
                                totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                // limit={Number(searchParams.get('limit'))}
                                limit={parseInt(limit)}
                            />
                        </div>
                    </div>}
                </>:<>
                    {data?.data?.length===0 && (searchParams.get("start_date")!==null||searchParams.get("end_date")!==null) ?
                        <SearchEmptyScreen text={"No exact matches found. Please try a different search"} setSkip={setSkip}/>
                        :
                        <Emptyscreen
                            title={"Activity Log"}
                            FirstPTag={"No activity log to view yet."}
                        />
                        // status==="rejected"&&<SearchEmptyScreen text={"No data found"} />
                    }
                </>}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
            

            </div>
        </div>
    )
}
